<template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <div class="card">
            <div class="card-header">
                <h5>Statements</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table>
                        <thead>
                            <tr>
                                <th>Statement Year</th>
                                <th class="account-table-center">Actions</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>2020</td>
                                <td class="account-table-center"><a href="" class="btn btn-xs btn-primary">View</a>	</td>	
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2019</td>
                                <td class="account-table-center"><a href="" class="btn btn-xs btn-primary">View</a>	</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2018</td>
                                <td class="account-table-center"><a href="" class="btn btn-xs btn-primary">View</a>	</td>	
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2017</td>
                                <td class="account-table-center"><a href="" class="btn btn-xs btn-primary">View</a>	</td>	
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>                            
        </div>
        
        <div class="block-space--layout--divider-xs"></div>					
    </div>
</template>